import { Spinner, Center, Text, VStack } from "@chakra-ui/react"

function Loadspinner({toggleProp}){

    return(
        <div>
            <Center minHeight="100vh" backgroundColor={toggleProp && "#11001f"} color={toggleProp && "white"} >
                <VStack>
                <Spinner size="xl" width={70} height={70} borderWidth={6} color="blue.600"  emptyColor="#404040" speed="0.65s"/>
                <Text fontSize="xl">Loading...</Text>
                </VStack>

            </Center>
            

        </div>
    )
}

export default Loadspinner